export default "__VITE_ASSET__DM56N06r__"